export const SelectStyles = {
    control: (baseStyles, state) => ({
        ...baseStyles,
        width: '100%',
        fontFamily: 'Avenir LT Pro',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '16.8px',
        height: '50px',
        borderRadius: '10px',
        border: state.isFocused
            ? '2px solid #B9A978 !important'
            : '1px solid #DFEAF2',
        boxShadow: '#B9A978',
        backgroundColor: '#181b20',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#0E1C44'
            : state.isFocused
            ? '#6b89e1'
            : provided.backgroundColor,
        color: state.isSelected
            ? 'white'
            : state.isFocused
            ? 'white'
            : "white",
        textTransform: 'math-auto',
        fontFamily: 'Avenir LT Pro',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '16.8px',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    singleValue: (provided) => ({
        ...provided,
        // color: '#718EBF !important;',
        fontFamily: 'Avenir LT Pro',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '16.8px',
        color: '#eff2f7',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#718EBF !important;',
        fontFamily: 'Avenir LT Pro',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '16.8px',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: '9',
        backgroundColor: '#181b20',
        border: '1px solid #DFEAF2',
    }),
}
